export default __webpack_public_path__ + "static/media/c1.f085ee30.png";